var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-create-container"},[_c('NotificationForm',{attrs:{"title":"Create Notification"},on:{"cancel":_vm.cancel,"post":_vm.post}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }